import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader'
import CONSTANTS from '../../constants'

const { GCPPROJECTS_API_URL } = CONSTANTS

export type GcpProjectDetailsUpdate = {
	gcpProjectID: string
	action: 'UPDATE_DETAILS'
	details: Record<string, unknown>
}

const updateGcpProjectDetails = async (
	payload: GcpProjectDetailsUpdate
): Promise<any> => {
	const response = await fetchWithAuthorizationHeader(`${GCPPROJECTS_API_URL}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			action: 'UPDATE_DETAILS'
		},
		body: JSON.stringify(payload)
	})

	if (!response.ok) {
		const message = await response.text()
		throw new Error(`Failed to update GCP project details: ${message}`)
	}

	return response.json()
}

export default updateGcpProjectDetails
